import { Aggregator, Column } from 'angular-slickgrid';
import { AggregatorTotalsHandler } from 'src/app/types/@types/sl-v-types';
import { SLAggregator } from './slaggregator';

export class SumAggregator extends SLAggregator {

	protected _name = 'sum';
	protected _label = 'Sum';
	constructor() {
		super();
	}
	init() {
		super.init();
	}

	Accumulate(item: any, column: Column<any>) {
		if (!item) {
			return;
		}
		if ((!item[column.id] && (item[column.id] !== 0)) || isNaN(Number(item[column.id]))) {
			return;
		}
		if (this._value[column.id] === undefined) {
			this._value[column.id] = Number(item[column.id]);
		} else {
			this._value[column.id] += Number(item[column.id]);
		}
	}
	SetTotals(totals: any, completeHandler?: AggregatorTotalsHandler) {
		super.SetTotals(totals);
		this.EndAggregation(totals, completeHandler);
	}
}